import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InstrumentRequestState = {
  dataType: TypeInstrumentRequest[];
  dataStatus: StatusInstrumentRequest[];
};

export const instrumentRequestInitialState: InstrumentRequestState = {
  dataType: [],
  dataStatus: [],
};

const slice = createSlice({
  name: 'instrumentRequest',
  initialState: instrumentRequestInitialState,
  reducers: {
    setInstrumentRequestTypeAction(
      state,
      { payload }: PayloadAction<{ dataType: TypeInstrumentRequest[] }>,
    ) {
      state.dataType = payload.dataType;
    },
    setInstrumentRequestStatusAction(
      state,
      { payload }: PayloadAction<{ dataStatus: StatusInstrumentRequest[] }>,
    ) {
      state.dataStatus = payload.dataStatus;
    },
  },
});

export const { setInstrumentRequestTypeAction, setInstrumentRequestStatusAction } = slice.actions;
export default slice.reducer;
